
function calculate_percentile(value, norm_mean, norms_sd) 
{
    let z = (value - norm_mean) / norms_sd;
    z = Math.max(-3, Math.min(3, z)) // clip z to [-3, 3] so that approximation is valid to to 1 decimal
    let sum = z,
    product = z;

    let z2 = z * z;

    for (var i = 1; i < 25; i++) {
        product *= z2 / (2 * i + 1);
        sum += product;
    }
    const cv = Math.round((0.5 + (sum / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * z2)) * 1e5) / 1e5;

    // check if '[sec]' is in currentInputName
    let percentile = cv * 100

    return percentile;
}

export default calculate_percentile;
